import styled from 'styled-components'

export const MainHome = styled.main`

`
